import { Box, Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { Form } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import AdminUsersTable from "components/datagrid/AdminUsersTable";
import apis from "../../services";

//by default pageinatoin limit
const PAGE_LIMIT = 10;

export const AdminUsers = () => {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: PAGE_LIMIT,
    totalPages: 1,
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPage(1);
      setSearch(searchInput.trim());
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchInput]);

  // get all users list
  const fetchAllUsers = async () => {
    setLoading(true);
    try {
      const res = await apis.getAllUser({
        search,
        page,
        limit: PAGE_LIMIT,
        includeDeleted: true,
      });

      if (res?.data?.status) {
        setUsers(res?.data?.users || []);
        setPagination(
          res?.data?.pagination || {
            total: res?.data?.users?.length || 0,
            page,
            limit: PAGE_LIMIT,
            totalPages: 1,
          }
        );
      } else {
        toast.error(res?.data?.message || "Unable to load users");
      }
    } catch (error) {
      toast.error(error?.message || "Unable to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, [page, search]);

  const onPageChange = (direction) => {
    if (direction === "prev" && page === 1) return;
    if (direction === "next" && page >= pagination.totalPages) return;

    setPage((currentPage) =>
      direction === "next" ? currentPage + 1 : currentPage - 1
    );
  };

  const { rows, columns } = AdminUsersTable(
    users,
    (page - 1) * PAGE_LIMIT
  );

  return (
    <Box className="dashboard-main">
      <AdminNewSidebar />
      <div className="dashboard-section-main">
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Header />

          {loading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Container sx={{ mt: 4, mb: 4 }} className="mainContainerComp">
              <div className="flex-with-title">
                <h3 className="dashboard-title">{t("titles.users")}</h3>
              </div>

              <Form.Group className="my-2" style={{ position: "relative" }}>
                <Form.Label>Search by name, email, or wallet ID</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter name, email, or wallet ID"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <div className="searchCon">
                  <CiSearch className="search-icon" color="#AFAEAE" fontSize={18} />
                </div>
              </Form.Group>

              <Grid
                item
                container
                justifyContent="flex-end"
                className="mt-4"
                sx={{ height: "600px", position: "relative", zIndex: "1" }}
              >
                <DataGrid
                  rows={rows}
                  columns={columns}
                  hideFooter
                  disableSelectionOnClick
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                  }
                />
                <img
                  src="/assets/images/frameCardBG.png"
                  alt="frameCardBG"
                  style={{
                    position: "absolute",
                    bottom: "-46px",
                    left: "-24px",
                    width: "296px",
                    zIndex: "-1",
                  }}
                  className="card-bg-img"
                />
              </Grid>

              <div className="pagination-container">
                <div>Total: {pagination.total}</div>
                <div>
                  <button
                    className="paginator"
                    disabled={page === 1}
                    onClick={() => onPageChange("prev")}
                  >
                    <IoIosArrowBack />
                  </button>
                  Page {pagination.page} of {pagination.totalPages}
                  <button
                    className="paginator"
                    disabled={page >= pagination.totalPages}
                    onClick={() => onPageChange("next")}
                  >
                    <IoIosArrowForward />
                  </button>
                </div>
              </div>
            </Container>
          )}
        </Box>
      </div>
    </Box>
  );
};

export default AdminUsers;
